import { WarningFilled } from '@ant-design/icons'
import { Flex, Tag, Typography } from 'antd'
import { ProviderClient } from '~/plugins/data-connector/providers/abstract/provider.client'
import { useProvider } from '../../hooks/useProvider'

type Props = {
  provider?: ProviderClient
  providerKey?: string
}

export const ProviderLabel: React.FC<Props> = ({ provider, providerKey }) => {
  const { providerClient: providerClient } = useProvider({
    providerKey: providerKey,
  })

  const label = (provider ?? providerClient)?.description?.label ?? (
    <Tag color="danger">{providerKey}</Tag>
  )

  const icon = (provider ?? providerClient)?.description?.icon ?? (
    <WarningFilled />
  )

  return (
    <Flex gap={8} align="center" title={provider?.key ?? providerClient?.key}>
      <Flex
        style={{ height: '28px', width: '28px' }}
        align="center"
        justify="center"
      >
        {icon}
      </Flex>
      <Typography.Text ellipsis style={{ color: 'inherit' }}>
        {label}
      </Typography.Text>
    </Flex>
  )
}
